module.exports = __webpack_public_path__ + "img/company-green-icon.df1a01b2.svg";